import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { LazyAutoEnrollModal } from "@faire/retailer-visitor-shared/components/Notifications/Components/InsiderAutoEnrollBanner/LazyAutoEnrollModal";
import { useInsiderState } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderState";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { Button } from "@faire/web--source/slate/Button";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackPromotionalEventsPdpPromoBannerClick } from "@faire/web-api--source/events/promotionalEvents/click/pdpPromoBanner";
import { trackRetailerTeamManagementInsiderMarketingPageLearnMoreRedirectClick } from "@faire/web-api--source/events/retailerTeamManagement/click/insiderMarketingPageLearnMoreRedirect";
import { IInformationMessage } from "@faire/web-api--source/indigofair/data/IInformationMessage";
import { IInsiderModalRequest } from "@faire/web-api--source/indigofair/insider/IInsiderModalRequest";
import insiderMarketingPage from "@faire/web-api--source/routes/user/insider/info";
import React, { Suspense, useState } from "react";
var INSIDER_BANNER_TYPES_WITH_CONDITIONALLY_RENDERED_CTA = [
    IInformationMessage.Type.INSIDER_UPSELL,
    IInformationMessage.Type.INSIDER_UNDER_THRESHOLD,
    IInformationMessage.Type.INSIDER_UNPAID_NOTICE,
    IInformationMessage.Type.INSIDER_UNPAID_RECOVER
];
export var CtaLink = function(param) {
    var type = param.type, cta_text = param.cta_text, help_link = param.help_link;
    var _useInsiderState = useInsiderState(), isInsiderAutoEnrollTrial = _useInsiderState.isInsiderAutoEnrollTrial, isInsiderActive = _useInsiderState.isInsiderActive;
    var userCanPlaceOrder = useUserStore([
        "userCanPlaceOrder"
    ]).userCanPlaceOrder;
    var _useState = _sliced_to_array(useState(false), 2), isModalShowing = _useState[0], setIsModalShowing = _useState[1];
    if (INSIDER_BANNER_TYPES_WITH_CONDITIONALLY_RENDERED_CTA.some(function(t) {
        return t === type;
    }) && isInsiderActive && !isInsiderAutoEnrollTrial) {
        return null;
    }
    var isUpSellOrUnderThreshold = type === IInformationMessage.Type.INSIDER_UPSELL || type === IInformationMessage.Type.INSIDER_UNDER_THRESHOLD;
    if (isUpSellOrUnderThreshold && isInsiderAutoEnrollTrial) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                "\xa0",
                /*#__PURE__*/ _jsx(Button, {
                    variant: "tertiary",
                    onClick: function() {
                        setIsModalShowing(true);
                        trackPromotionalEventsPdpPromoBannerClick(IInformationMessage.Type.INSIDER_UPSELL);
                    },
                    "data-test-id": "productPromoBannerInsiderLearnMoreButton",
                    children: cta_text !== null && cta_text !== void 0 ? cta_text : ""
                }),
                isModalShowing ? /*#__PURE__*/ _jsx(Suspense, {
                    fallback: null,
                    children: /*#__PURE__*/ _jsx(LazyAutoEnrollModal, {
                        onCloseModal: function() {
                            return setIsModalShowing(false);
                        }
                    })
                }) : null
            ]
        });
    }
    if (type === IInformationMessage.Type.INSIDER_UPSELL) {
        var link = !userCanPlaceOrder ? insiderMarketingPage() : getCurrentPath().append({
            insiderEnrolment: IInsiderModalRequest.InsiderModalContext.PDP
        }).toString();
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                "\xa0",
                /*#__PURE__*/ _jsx(Button, {
                    variant: "tertiary",
                    linkTo: link,
                    onClick: function() {
                        if (!userCanPlaceOrder) {
                            trackRetailerTeamManagementInsiderMarketingPageLearnMoreRedirectClick("product-promo-banner");
                        }
                        trackPromotionalEventsPdpPromoBannerClick(IInformationMessage.Type.INSIDER_UPSELL);
                    },
                    "data-test-id": "productPromoBannerInsiderLearnMoreButton",
                    children: cta_text !== null && cta_text !== void 0 ? cta_text : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "M6VfBg",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Learn more"
                            }
                        ]
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: cta_text && help_link ? /*#__PURE__*/ _jsx(_Fragment, {
            children: /*#__PURE__*/ _jsx(Button, {
                variant: "tertiary",
                linkTo: help_link,
                target: "_blank",
                children: cta_text
            })
        }) : null
    });
};
